export const dialogTitleCaptionLineHeight = '2.125rem';
